var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import { useState } from 'react';
//import { Chart } from '@kaizenplatform/kaizen-chartjs';
function usePreviewChart(data) {
    var _a = useState(), chartPreview = _a[0], setChartPreview = _a[1];
    var _b = useState(false), previewable = _b[0], setPreviewable = _b[1];
    // any master table needs to be brokendown into smaller tables by breakdown values
    var _seperateTablesByBreakdownValues = function (tables, columnName, // Breakdown key, eg: device
    columnValues) {
        var new_tables = [];
        columnValues.map(function (columnValue, i) {
            for (var _i = 0, tables_1 = tables; _i < tables_1.length; _i++) {
                var table = tables_1[_i];
                new_tables.push({
                    breakdownValues: table.breakdownValues ? __spreadArrays(table.breakdownValues, [columnValue]) : [columnValue],
                    rows: table.rows.filter(function (row) {
                        return row[columnName] === columnValue;
                    }),
                });
            }
            return i;
        });
        return new_tables;
    };
    var _generateDatasets = function (measure, xLabel, table, breakdowns) {
        var _a, _b;
        var datasets = [];
        datasets.push({
            id: Math.floor(Math.random() * 100),
            type: measure.type,
            label: measure.label + ": " + table.breakdownValues,
            percentage: measure.label === 'CVR' ? true : false,
            position: measure.type === 'BAR' ? 'RIGHT' : 'LEFT',
            customFormulaType: (_a = measure.customFormulaType) !== null && _a !== void 0 ? _a : null,
            rows: (_b = table.rows) === null || _b === void 0 ? void 0 : _b.map(function (row, i) {
                return {
                    // Chart.structure.dimensions is expected be length 1 for normal charts for now.
                    columns: [row[xLabel]],
                    value: row[measure.label].toString(),
                    breakdown: breakdowns.map(function (obj) { return obj.label; }),
                };
            }),
        });
        return datasets;
    };
    var setPreviewInputs = function (chartSchema, dimensions) {
        var _a, _b, _c;
        if (!chartSchema) {
            throw new Error('Not sure which graph to generate. please select a chart');
            setPreviewable(false);
            setChartPreview(null);
            return;
        }
        setPreviewable(dimensions
            ? Object.entries(chartSchema)
                .filter(function (_a) {
                var _b;
                var key = _a[0], value = _a[1];
                return (_b = value.required) !== null && _b !== void 0 ? _b : null;
            })
                .every(function (_a) {
                var key = _a[0], d = _a[1];
                return dimensions[key] && d.required.length <= dimensions[key].length;
            })
            : false);
        var breakdowns = (_a = dimensions === null || dimensions === void 0 ? void 0 : dimensions.breakdowns) !== null && _a !== void 0 ? _a : null;
        var dataForBreakdown = [{ rows: data }];
        var breakdownCombinations;
        if (breakdowns) {
            // in order to mimic datasets with breakdowns
            // not only breakdown keys but their values are required
            breakdownCombinations = breakdowns.map(function (b) {
                return {
                    key: b.label,
                    values: data === null || data === void 0 ? void 0 : data.map(function (row) { return row[b.label]; }).filter(function (v, i, a) { return a.indexOf(v) === i; }),
                };
            });
            for (var _i = 0, breakdownCombinations_1 = breakdownCombinations; _i < breakdownCombinations_1.length; _i++) {
                var breakdown = breakdownCombinations_1[_i];
                dataForBreakdown = _seperateTablesByBreakdownValues(dataForBreakdown, breakdown.key, breakdown.values);
            }
        }
        var reducedDataForDimension = data.reduce(function (unique, row) {
            return unique.some(function (r) { return r[dimensions.dimensions[0].label] === row[dimensions.dimensions[0].label]; })
                ? unique
                : __spreadArrays(unique, [row]);
        }, []);
        var datasets = [];
        var originalDatasets = [];
        var _loop_1 = function (dataset) {
            if (breakdowns) {
                for (var _i = 0, dataForBreakdown_1 = dataForBreakdown; _i < dataForBreakdown_1.length; _i++) {
                    var table = dataForBreakdown_1[_i];
                    datasets.push({
                        id: Math.floor(Math.random() * 100),
                        type: dataset.type,
                        label: dataset.label + ": " + table.breakdownValues,
                        percentage: dataset.label === 'CVR' ? true : false,
                        position: dataset.type === 'BAR' ? 'RIGHT' : 'LEFT',
                        customFormulaType: (_b = dataset.customFormulaType) !== null && _b !== void 0 ? _b : null,
                        rows: (_c = table.rows) === null || _c === void 0 ? void 0 : _c.map(function (row, i) {
                            return {
                                // Chart.structure.dimensions is expected be length 1 for normal charts for now.
                                columns: [row[dimensions.dimensions[0].label]],
                                value: row[dataset.label].toString(),
                                breakdown: breakdowns.map(function (obj) { return obj.label; }),
                            };
                        }),
                    });
                    originalDatasets.push({ label: dataset.label + ": " + table.breakdownValues });
                }
            }
            else {
                var d = {
                    id: Math.floor(Math.random() * 100),
                    type: dataset.type,
                    label: dataset.label,
                    percentage: dataset.label === 'CVR' ? true : false,
                    position: dataset.type === 'BAR' ? 'RIGHT' : 'LEFT',
                    rows: reducedDataForDimension.map(function (row) {
                        return {
                            // Chart.structure.dimensions is expected be length 1 for normal charts for now.
                            columns: [row[dimensions.dimensions[0].label]],
                            value: row[dataset.label].toString(),
                            breakdown: null,
                        };
                    }),
                };
                datasets.push(d);
                originalDatasets.push({ label: dataset.label });
            }
        };
        for (var _d = 0, _e = dimensions.measures; _d < _e.length; _d++) {
            var dataset = _e[_d];
            _loop_1(dataset);
        }
        var chartData = {
            id: 0,
            type: chartSchema.type,
            name: 'Chart Preview',
            structure: {
                dimensions: [
                    {
                        id: 1,
                        label: dimensions.dimensions[0].label,
                        columns: reducedDataForDimension.map(function (row) {
                            if (row[dimensions.dimensions[0].label].match(/^\d{4}-\d{2}-\d{2}$/)) {
                                return row[dimensions.dimensions[0].label].replace(/-/g, '/').substr(5);
                            }
                            return row[dimensions.dimensions[0].label];
                        }),
                    },
                ],
                datasets: datasets,
                originalDatasets: originalDatasets,
            },
            breakdowns: breakdowns,
            header: {
                scope: null,
                breakdowns: breakdowns,
            },
            frequencies: [],
            table: chartSchema.type === 'TABLE'
                ? {
                    rows: data.map(function (r) {
                        return Object.entries(dimensions).flatMap(function (_a) {
                            var k = _a[0], v = _a[1];
                            return v.flatMap(function (d) { return r[d.label]; });
                        });
                    }),
                    columns: Object.entries(dimensions).flatMap(function (_a) {
                        var k = _a[0], v = _a[1];
                        return v.flatMap(function (d) { return d.label; });
                    }),
                }
                : null,
        };
        setChartPreview(chartData);
    };
    return { chartPreview: chartPreview, setPreviewInputs: setPreviewInputs, previewable: previewable };
}
export default usePreviewChart;
